<script>
import config from "@/helpers/config"
import niceFunctions from "@/helpers/niceFunctions"
import SvgTransition from '@/components/SvgTransition.vue'
export default {
    components: { SvgTransition },
    data() {
        return {
            filterDays: [
                { day: 10, name: 'Alla dagar', selected: true},
                { day: 1, name: 'Måndag', selected: false },
                { day: 2, name: 'Tisdag', selected: false},
                { day: 3, name: 'Onsdag', selected: false},
                { day: 4, name: 'Torsdag', selected: false},
                { day: 5, name: 'Fredag', selected: false},
                { day: 6, name: 'Lördag', selected: false},
                { day: 0, name: 'Söndag', selected: false}
            ]
        }
    },
    created() {  
        this.$cache.createCache('publicPage', 'public-page/',  {id: this.$route.params.id, domain: window.location.hostname });        
    },
    computed: {
        url() { return config.urlToServer },  
        publicPageColors() { return this.$store.state.publicPage != null ?  this.$store.state.publicPage.publicPageColors : null },
        publicPage() { return this.$store.state.publicPage != null ?  this.$store.state.publicPage.publicPage : null },
        height() { return window.innerHeight/1.3 + 'px' },
        availableCourses() { return this.$store.state.publicPage != null ?  this.$store.state.publicPage.availableCourses : [] },
        instructor() { return this.$store.state.publicPage != null ?  this.$store.state.publicPage.instructors.find(x => x.id == this.$route.params.instructorid) : [] },
        settings() { return this.$store.state.publicPage != null ?  this.$store.state.publicPage.settings : null },
        hasSettings() { return this.settings != null },
        daysAvailable() {
            const days = this.availableCourses.flatMap(course => course.occations_week_days);
            return this.filterDays.filter(x => days.includes(x.day) || x.day == 10);
        },        
        daysSelected() {
            return this.daysAvailable.filter(x => x.selected).map(x => x.day)
        }
    },
    methods:
    {
        goTopage(courseItem)
        {
            $(window).scrollTop(0);           
            this.$router.push({ name: niceFunctions.getPageName('courseDetails'), params: { id: this.$route.params.id, courseid: courseItem.id } })
        } ,
        blurOut(booking)
        {
            if(this.availableCourses.filter(x => x.hovered) == 0) {
                return false;
            }
            else if(booking.hovered) {
                return false;
            }
            return true;
        },
        getColor(location)
        {
            return niceFunctions.getColor(this.publicPageColors, location)
        },
        filterDay(day) {
            day.selected = !day.selected;
            if(day.day != 10 && day.selected) {
                this.filterDays[0].selected = false;
            } else if(day.selected) {
                this.filterDays.forEach(day => {
                    day.selected = day.day == 10 ? true : false;
                });
            }
        },
        
        displayCourse(course) {
            if(!course.instructors.some(x => x == this.instructor.name)) {
               return false;
            }
            var dayMatch = this.filterDays[0].selected;

            course.occations_week_days.forEach((occation) => {
                if(this.daysSelected.includes(occation)) {
                    dayMatch = true;
                }
            });
            
            return dayMatch;
        }   
    },
    watch: {
        instructorsAvailable(newList) {  
            if(newList.length > 0)        
                this.instructorsList = newList;
        }
    }
}
</script>
<template>
   <section  class="public-page" v-if="publicPage != null && settings != null">   
        <div class="top-public position-relative" :style="{ 'height': height, 'background-image': 'url(' + url + 'uploads/'+ publicPage.customer_id+'/images/'+availableCourses[0].image_name + ')' }">
            <SvgTransition :publicPage="publicPage"></SvgTransition>   
        </div>
        <div class="text-section overflow-auto" style="max-width: none; margin-top: 70px;">
            <h1 :style="{ 'color': getColor('header_color_on_white_bg') }" class="margin-top-25px" style="margin-left: 16px;">{{ instructor.name }}</h1> 
            <div class="g-30">
                <div class="CourseDetails-instructors">             
                    <div :style="{ 'background-color':  getColor('background_color') }">
                        <img :src="url + 'uploads/'+ publicPage.customer_id+'/images/thumbnails/'+ instructor.image_name" />  
                        <h3 style="padding:0px 15px">{{ instructor.name }}</h3>
                        <p v-html="instructor.description"></p>
                    </div>                    
                </div>
            </div>
            <div class="g-70"> 
                <div v-if="daysAvailable.length > 1 || instructorsList.length > 1" class="Courses-filter-section" :style="{'background-color': getColor('background_color') }">
                    <h3>Filtera kurser</h3>                   
                    <p v-if="daysAvailable.length > 1">
                        <b>Dagar: &nbsp;</b>
                        <button v-for="day in daysAvailable" class="btn" :class="day.selected ? 'btn-selected' : ''" @click="filterDay(day)">{{ day.name }}</button>  
                    </p>              
                </div>
                <div class="Courses-wrapper" v-if="availableCourses.filter(x => displayCourse(x)).length > 0">
                    <div v-for="course in availableCourses.filter(x => displayCourse(x))" class="Courses-course-item"> 
                        <div @mouseover="course.hovered = true" @mouseout="course.hovered = false" :class="blurOut(course) ? 'ImageGallery-grayscale' : 'ImageGallery-no-grayscale'" >
                            <div class="position-relative">
                                <div class="Courses-course-img-area">
                                    <img v-if="course.image_id" :src="url + 'uploads/'+ publicPage.customer_id+'/images/thumbnails/'+ course.image_name" />  
                                    <i v-else class="fa-regular fa-image wow-color wow-color-bg"></i>
                                </div>
                                <h4 :style="{'background-color': getColor('background_color') }">{{ course.name }}</h4>
                            </div>
                            <div class="Courses-course-max-booking">
                                <i><span v-html="course.description.slice(0, 100) + '...'"></span></i>
                                <div class="margin-top-15">Max antal deltagare: {{ course.max_number_of_participents }} <span style="color: red" v-if="course.max_number_of_participents - course.number_of_approved_participants <= course.show_few_left_at_this_number">Fåtal platser kvar!</span></div>
                                <div>Pris: <b>{{ course.price }} kr</b></div>
                                <div>Kursstart: {{ course.course_start }}</div>
                                <div>Antal tillfällen: {{ course.number_of_occations }} st </div>
                                
                                <button class="Courses-btn float-right margin-top-15" :style="{'background-color': getColor('background_color') }" @click="goTopage(course)">Läs mer</button>
                            </div>
                        </div>              
                    </div>    
                </div>
                <div v-else style="padding: 50px 30px">
                    Inga {{ settings.Course.plural }} hittade. &#x1F61E;
                </div>
            </div>
        </div>
   </section>
</template>
<style scoped>
    .Courses-btn{
        background-color: rgb(181, 205, 191);
    padding: 10px 20px;
    font-size: 21px;
    color: black;
    border: 0px solid lightgray;
    font-family: 'Raleway', sans-serif;
    -webkit-font-smoothing: antialiased;
    font-weight: 700;
    cursor: pointer;
    }
    
    .Courses-filter-section {     
        padding: 1px 20px 20px 20px;
    }

    .Courses-btn:hover {
        filter: brightness(0.8);
    }

    .Courses-wrapper
    {
        display:flex;
        flex-wrap: wrap;
    }
    .Courses-course-item
    {
        padding:10px; 
        margin: 20px;
        background: white;
        width: calc(33% - 60px);
        box-shadow: 1px 1px #ddd;
    }

    .Courses-course-img-area
    {
        height: 250px; 
        overflow: hidden;
        text-align: center;
        display: flex;
        align-items: flex-end;
    }

    .Courses-course-max-booking
    {
        margin: 30px 10px 10px 10px;
        overflow:auto;
    }

    .Courses-course-wrapper
    {
        display:flex;
        flex-wrap: wrap;

    }

    .Courses-course-img-area i
    {
        display:block;
        padding-top: 40px;
        font-size: 60px;
        background-color:aliceblue;
        height: 100vh;
    }

    img
    {
        width: 100%;
    }

    h4{
        margin-bottom:0px;
        padding:10px;
        width: 50%;
        position: absolute;
        bottom: -20px;
        left: 10px;
    }

    .CourseDetails-instructors {
        padding: 0px 15px;
    }
    
    .CourseDetails-instructors div {
        padding: 10px;
    }
    
    .CourseDetails-instructors p {
        font-size: 14px;
        text-align: justify;
        line-height: 24px;
        padding: 0px 15px;
    }
    
    .CourseDetails-instructors img {
       width:100%;
    }
    
.ImageGallery-grayscale {
    filter:grayscale(80%);
    transition: ease-out 0.2s;
}

.ImageGallery-no-grayscale {
    filter:grayscale(0%);
    transition: ease-out 0.2s;
}

    @media only screen and (max-width: 1000px) {
        .Courses-course-img-area {
            height: auto;
            width: auto;
        }

        .CourseDetails-instructors {
            margin-bottom: 20px;
            padding: inherit;
        }
        .Courses-course-item
        {
            padding:10px; 
            margin: 30px;
            width: calc(100% - 80px);
        }       
    }
</style>